import { render, staticRenderFns } from "./DynamicFooter.vue?vue&type=template&id=57d9e61b"
import script from "./DynamicFooter.vue?vue&type=script&lang=js"
export * from "./DynamicFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports